/**
 * User-facing copy for the root route error boundary (priority-A catalog).
 */

export const SUPPORT_CONTACT_EMAIL = "aide.portail@cncc.fr" as const;

export const SUPPORT_CONTACT_FOOTER =
  "Si le problème persiste, écrivez-nous en indiquant l'heure et, si possible, le détail technique." as const;

export type RootErrorCatalogEntry = {
  title: string;
  message: string;
};

export const ROOT_ERROR_CATALOG = {
  conversation_not_found: {
    title: "Conversation introuvable",
    message:
      "Cette conversation n'existe pas ou n'est plus accessible depuis votre compte.",
  },
  shared_conversation_unavailable: {
    title: "Partage de conversation indisponible",
    message:
      "Impossible d'afficher cette conversation. Le lien est invalide, expiré, ou le partage a été désactivé.",
  },
  not_found: {
    title: "Ressource introuvable",
    message: "L'élément demandé est introuvable.",
  },
  api_error: {
    title: "Service momentanément indisponible",
    message:
      "SidonIAssist rencontre un incident technique.\nRéessayez dans quelques minutes.",
  },
  unknown_error: {
    title: "Service momentanément indisponible",
    message:
      "SidonIAssist rencontre un incident technique.\nRéessayez dans quelques minutes.",
  },
  network_error: {
    title: "Connexion interrompue",
    message:
      "Impossible de joindre le serveur.\nVérifiez votre réseau puis réessayez.",
  },
  auth_dependency_unavailable: {
    title: "Authentification indisponible",
    message:
      "Le service de connexion est momentanément indisponible.\nRéessayez plus tard.",
  },
  default: {
    title: "Une erreur est survenue",
    message:
      "Nous n'avons pas pu terminer cette action.\nSi le problème persiste, contactez le support en fournissant le détail technique ci-dessous.",
  },
} as const satisfies Record<string, RootErrorCatalogEntry>;

export type RootErrorCatalogKey = keyof typeof ROOT_ERROR_CATALOG;
